import LocationOnIcon from '@mui/icons-material/LocationOn';
import PublicIcon from '@mui/icons-material/Public';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const EventMaps = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                py: { xs: 8, md: 12 },
                background: `linear-gradient(135deg, ${theme.palette.grey[50]} 0%, white 60%, ${theme.palette.primary.main}08 100%)`,
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: -60,
                    right: -60,
                    width: 220,
                    height: 220,
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}15, ${theme.palette.secondary.main}15)`,
                    zIndex: 0,
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: -120,
                    left: -120,
                    width: 320,
                    height: 320,
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.secondary.main}10, ${theme.palette.primary.main}10)`,
                    zIndex: 0,
                }}
            />

            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Card
                    sx={{
                        borderRadius: 4,
                        background: `linear-gradient(135deg, ${theme.palette.primary.main}08 0%, ${theme.palette.secondary.main}08 100%)`,
                        border: `2px solid ${theme.palette.primary.main}20`,
                        boxShadow: '0 12px 40px rgba(0,0,0,0.1)',
                    }}
                >
                    <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 3,
                            }}
                        >
                            <LocationOnIcon
                                sx={{
                                    fontSize: 24,
                                    color: theme.palette.success.main,
                                    mr: 2,
                                }}
                            />
                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 700, color: 'text.primary' }}
                            >
                                Event Location
                            </Typography>
                        </Box>

                        <Divider sx={{ mb: 4 }} />
                        <Box
                            sx={{
                                p: 3,
                                backgroundColor: 'white',
                                borderRadius: 3,
                                border: `1px solid ${theme.palette.grey[200]}`,
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Box>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color:
                                                theme.palette.success.darker ??
                                                theme.palette.success.main,
                                            fontWeight: 700,
                                            fontSize: '1.05rem',
                                            mb: 0.5,
                                        }}
                                    >
                                        Padma Hotel Semarang
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            mb: 1,
                                        }}
                                    >
                                        <PublicIcon
                                            sx={{
                                                fontSize: 16,
                                                color: 'text.secondary',
                                                mr: 1,
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: 'text.secondary',
                                                fontSize: '0.95rem',
                                            }}
                                        >
                                            Semarang, Central Java, Indonesia
                                        </Typography>
                                    </Box>
                                </Box>

                                <Button
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    href="https://www.google.com/maps/search/?api=1&query=Padma%20Hotel%20Semarang"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    startIcon={<LocationOnIcon />}
                                    sx={{
                                        mt: 1,
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        fontWeight: 600,
                                    }}
                                >
                                    View on Google Maps
                                </Button>
                            </Box>

                            <Box
                                sx={{
                                    mt: 2,
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    border: `1px solid ${theme.palette.grey[200]}`,
                                }}
                            >
                                <Box
                                    component="iframe"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.00045723917!2d110.41398567644134!3d-7.009227792992195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e708bb0f3340317%3A0x695373881ac0dbf0!2sPadma%20Hotel%20Semarang!5e0!3m2!1sen!2sid!4v1762568797254!5m2!1sen!2sid"
                                    sx={{
                                        width: '100%',
                                        height: 420,
                                        border: 0,
                                    }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Padma Hotel Semarang Location Map"
                                />
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default EventMaps;
